import { useState, useEffect } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../../assets/css/components/myNavbar/MyNavbar.css";

const EstaticeNavbar = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Har link ke liye check karta hai k current path match karta hai ya nahi
  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Navbar
      expand="lg"
      className={`ac-navbar ${scrolled ? "ac-navbar--scrolled" : ""}`}
      collapseOnSelect
    >
      <Container className="ac-navbar__container">

        {/* Logo */}
        <Navbar.Brand as={Link} to="/" className="ac-navbar__brand">
          <div className="ac-navbar__logo-icon">
            <span>E</span>
          </div>
          <div className="ac-navbar__logo-text">
            <span className="ac-navbar__logo-name">Estetica</span>
            <span className="ac-navbar__logo-tagline">SKIN & LASER CLINIC</span>
          </div>
        </Navbar.Brand>

        {/* Mobile Toggle */}
        <Navbar.Toggle
          aria-controls="ac-navbar-nav"
          className="ac-navbar__toggler"
        >
          <span className="ac-navbar__toggler-bar"></span>
          <span className="ac-navbar__toggler-bar"></span>
          <span className="ac-navbar__toggler-bar"></span>
        </Navbar.Toggle>

        {/* Nav Links */}
        <Navbar.Collapse id="ac-navbar-nav">
          <Nav className="mx-auto ac-navbar__nav">
            <Nav.Link
              as={Link}
              to="/"
              className={`ac-navbar__link ${isActive("/") ? "ac-navbar__link--active" : ""}`}
            >
              Home
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/about"
              className={`ac-navbar__link ${isActive("/about") ? "ac-navbar__link--active" : ""}`}
            >
              About
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/treatments"
              className={`ac-navbar__link ${isActive("/treatments") ? "ac-navbar__link--active" : ""}`}
            >
              Treatments
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/deals"
              className={`ac-navbar__link ${isActive("/deals") ? "ac-navbar__link--active" : ""}`}
            >
              Deals
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/blogs"
              className={`ac-navbar__link ${isActive("/blogs") ? "ac-navbar__link--active" : ""}`}
            >
              Blogs
            </Nav.Link>

             <Nav.Link
              as={Link}
              to="/terms-of-service"
              className={`ac-navbar__link ${isActive("/terms-of-service") ? "ac-navbar__link--active" : ""}`}
            >
             Terms Of Service
            </Nav.Link> 

               <Nav.Link
              as={Link}
              to="/privacy-policy"
              className={`ac-navbar__link ${isActive("/privacy-policy") ? "ac-navbar__link--active" : ""}`}
            >
           Privacy Policy
            </Nav.Link> 
          
          </Nav>

          {/* Login Button */}
          <div className="ac-navbar__cta">
            <Button className="ac-navbar__login-btn"
                onClick={() => navigate("/customer/login")}
                >
              <svg
                className="ac-navbar__login-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                <polyline points="10 17 15 12 10 7" />
                <line x1="15" y1="12" x2="3" y2="12" />
              </svg>
              Login
            </Button>
          </div>

             {/* <div className="ac-navbar__cta">
            <Button className="ac-navbar__login-btn"
                onClick={() => navigate("/customer/Contact")}
                >
              <svg
                className="ac-navbar__login-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                <polyline points="10 17 15 12 10 7" />
                <line x1="15" y1="12" x2="3" y2="12" />
              </svg>
              Contact
            </Button>
          </div> */}
        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
};

export default EstaticeNavbar;